import * as tslib_1 from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import Ripple from './Ripple';
import TouchRippleContainer from './TouchRippleContainer';
var DURATION = 550;
export var DELAY_RIPPLE = 80;
/**
 * @ignore - internal component.
 */
var TouchRipple = /** @class */ (function (_super) {
    tslib_1.__extends(TouchRipple, _super);
    function TouchRipple() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            nextKey: 0,
            ripples: [],
        };
        // Used to filter out mouse emulated events on mobile.
        _this.ignoringMouseDown = false;
        // We don't want to display the ripple for touch scroll events.
        _this.startTimer = null;
        /**
         * 有规律地摆动墨水扩散效果
         */
        _this.pulsate = function () {
            _this.start(null, { pulsate: true });
        };
        /**
         * 开始墨水扩散效果
         */
        _this.start = function (event, options, cb) {
            if (options === void 0) { options = {}; }
            if (cb === void 0) { cb = null; }
            var _a = options.pulsate, pulsate = _a === void 0 ? false : _a, _b = options.center, center = _b === void 0 ? _this.props.center || options.pulsate : _b, _c = options.fakeElement, fakeElement = _c === void 0 ? false : _c;
            if (event && event.type === 'mousedown' && _this.ignoringMouseDown) {
                _this.ignoringMouseDown = false;
                return;
            }
            if (event && event.type === 'touchstart') {
                _this.ignoringMouseDown = true;
            }
            var element = fakeElement ? null : ReactDOM.findDOMNode(_this);
            var rect = element
                ? element.getBoundingClientRect()
                : {
                    width: 0,
                    height: 0,
                    left: 0,
                    top: 0,
                };
            // Get the size of the ripple
            var rippleX;
            var rippleY;
            var rippleSize;
            var mouseEvent = event;
            var touchEvent = event;
            if (center ||
                (mouseEvent.clientX === 0 && mouseEvent.clientY === 0) ||
                (!mouseEvent.clientX && !touchEvent.touches)) {
                rippleX = Math.round(rect.width / 2);
                rippleY = Math.round(rect.height / 2);
            }
            else {
                var clientX = mouseEvent.clientX
                    ? mouseEvent.clientX
                    : touchEvent.touches[0].clientX;
                var clientY = mouseEvent.clientY
                    ? mouseEvent.clientY
                    : touchEvent.touches[0].clientY;
                rippleX = Math.round(clientX - rect.left);
                rippleY = Math.round(clientY - rect.top);
            }
            if (center) {
                rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);
                if (rippleSize % 2 === 0) {
                    rippleSize += 1;
                }
            }
            else {
                var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) *
                    2 +
                    2;
                var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) *
                    2 +
                    2;
                rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
            }
            // Touche devices
            if (touchEvent.touches) {
                // Prepare the ripple effect.
                _this.startTimerCommit = function () {
                    _this.startCommit({ pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb });
                };
                // Deplay the execution of the ripple effect.
                _this.startTimer = setTimeout(function () {
                    _this.startTimerCommit();
                    _this.startTimerCommit = null;
                }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
            }
            else {
                _this.startCommit({ pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb });
            }
        };
        /**
         * 提交墨水扩散效果
         */
        _this.startCommit = function (params) {
            var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
            var ripples = _this.state.ripples;
            // Add a ripple to the ripples array.
            ripples = ripples.concat([
                React.createElement(Ripple, { key: _this.state.nextKey, timeout: {
                        exit: DURATION,
                        enter: DURATION,
                    }, pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize }),
            ]);
            _this.setState({
                nextKey: _this.state.nextKey + 1,
                ripples: ripples,
            }, cb);
        };
        /**
         * 停止墨水扩散效果
         */
        _this.stop = function (event, cb) {
            clearTimeout(_this.startTimer);
            var ripples = _this.state.ripples;
            // The touch interaction occures to quickly.
            // We still want to show ripple effect.
            if (event.type === 'touchend' && _this.startTimerCommit) {
                event.persist();
                _this.startTimerCommit();
                _this.startTimerCommit = null;
                _this.startTimer = setTimeout(function () {
                    _this.stop(event, cb);
                }, 0);
                return;
            }
            _this.startTimerCommit = null;
            if (ripples && ripples.length) {
                _this.setState({
                    ripples: ripples.slice(1),
                }, cb);
            }
        };
        return _this;
    }
    TouchRipple.prototype.componentWillUnmount = function () {
        clearTimeout(this.startTimer);
    };
    TouchRipple.prototype.render = function () {
        var _a = this.props, center = _a.center, other = tslib_1.__rest(_a, ["center"]);
        return (React.createElement(TransitionGroup, tslib_1.__assign({ component: TouchRippleContainer, enter: true, exit: true }, other), this.state.ripples));
    };
    TouchRipple.defaultProps = {};
    return TouchRipple;
}(React.Component));
export default TouchRipple;
//# sourceMappingURL=TouchRipple.js.map